const API_URL = "https://fikasemail.fly.dev";
export const LOCAL_API_URL = "http://localhost:4000";
export default API_URL;
